import React from "react";

export default function LogoComponent() {
  return (
    <svg
      className="svg-logo"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.628906 14.0428C1.00605 16.5772 2.19576 18.8455 3.92513 20.5749L7.91325 16.5861C7.91736 12.5507 10.0108 8.62632 13.7569 6.46289L0.628906 14.0428Z"
        fill="#9B65C3"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.91325 16.5873C5.92605 16.5893 3.91142 16.0874 2.06616 15.0225C1.55599 14.7276 1.07668 14.3998 0.628906 14.0439C1.00605 16.5777 2.19576 18.846 3.92513 20.5754L7.91325 16.5873Z"
        fill="#9B65C3"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.91292 16.5865L3.9248 20.5746C5.65418 22.304 7.92252 23.4937 10.4562 23.8709L18.0361 10.7422C15.8727 14.4889 11.949 16.5824 7.91292 16.5865Z"
        fill="#BE63C5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.47772 22.434C8.4128 20.5887 7.91086 18.5748 7.91292 16.5869L3.9248 20.5757C5.65349 22.3044 7.92252 23.4948 10.4562 23.8713C10.1003 23.4235 9.77258 22.9442 9.47772 22.434Z"
        fill="#BF63C6"
      />
      <mask
        id="mask0"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="1"
        width="24"
        height="16"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.5 16.5871V1.25586H23.0241V16.5871H0.5Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M22.7782 1.25586L13.7576 6.46386C10.0109 8.62729 5.56606 8.4778 2.06823 6.46317C1.07326 8.18363 0.5 10.1791 0.5 12.3096C0.5 12.8986 0.545257 13.4773 0.628914 14.0437C1.07737 14.3996 1.556 14.7274 2.06617 15.0223H2.06686C3.91143 16.0872 5.92606 16.5891 7.91326 16.5871L23.0243 1.47597C22.9469 1.3978 22.8646 1.32443 22.7782 1.25586Z"
          fill="#3278B1"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.06616 15.0223C3.91142 16.0872 5.92536 16.5891 7.91325 16.5871C7.91736 12.551 10.0102 8.6273 13.7569 6.46387L0.628906 14.0438C1.07668 14.3996 1.55599 14.7274 2.06616 15.0223Z"
        fill="#3278B2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.06823 6.46289C1.07257 8.18266 0.5 10.1788 0.5 12.3086C0.5 12.8983 0.544571 13.4771 0.628914 14.0428L13.7569 6.46358C10.0102 8.62632 5.56537 8.47683 2.06823 6.46289Z"
        fill="#45A4EC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.0245 1.47531C22.9463 1.39714 22.864 1.32376 22.7783 1.25519C22.6645 1.16468 22.5431 1.08376 22.4169 1.01039C21.9877 0.762164 21.4905 0.618164 20.9591 0.618164H12.1909C7.8647 0.618164 4.08985 2.96948 2.06836 6.46251C5.5655 8.47714 10.0103 8.62662 13.757 6.46319C10.0103 8.62662 7.9175 12.5503 7.91339 16.5864C11.9495 16.5823 15.8732 14.4895 18.0366 10.7427L23.2446 1.72148C23.176 1.63508 23.1026 1.55348 23.0245 1.47531Z"
        fill="#19BB7D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.757 6.46354L22.7776 1.25554C22.6645 1.16503 22.5431 1.08411 22.4169 1.01074L2.06836 6.46286C5.5655 8.47748 10.0103 8.62697 13.757 6.46354Z"
        fill="#07C7FB"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.9591 0.618164H12.1909C7.8647 0.618164 4.08985 2.97016 2.06836 6.46319L22.4169 1.01039C21.9877 0.762164 21.4905 0.618164 20.9591 0.618164Z"
        fill="#59F2F7"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.0363 10.743L23.2443 1.72244C23.1757 1.63604 23.1024 1.55376 23.0242 1.47559L7.91309 16.5874C7.91104 18.5746 8.41298 20.5892 9.47789 22.4338C9.77275 22.9446 10.1005 23.4232 10.4564 23.871C11.0228 23.9554 11.6016 23.9999 12.1906 23.9999C14.3211 23.9999 16.3165 23.4274 18.037 22.4317C16.0224 18.9346 15.8729 14.4898 18.0363 10.743Z"
        fill="#DA3757"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.91309 16.5865C7.91104 18.5737 8.41298 20.5884 9.47789 22.4336C9.77275 22.9438 10.1005 23.4231 10.4564 23.8709L18.0363 10.7422C15.8729 14.4889 11.9492 16.5824 7.91309 16.5865Z"
        fill="#D33C4E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.0359 10.7432L10.4561 23.8712C11.0225 23.9555 11.6012 24.0001 12.1902 24.0001C14.3207 24.0001 16.3162 23.4275 18.0366 22.4319C16.022 18.9347 15.8725 14.4899 18.0359 10.7432Z"
        fill="#EE5A24"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.4891 2.08352C23.4157 1.95735 23.3348 1.83597 23.2443 1.72215C23.1757 1.63575 23.1023 1.55415 23.0242 1.47597C22.946 1.3978 22.8644 1.32443 22.778 1.25586L13.7567 6.46386C10.01 8.62729 7.9172 12.5509 7.91309 16.5871C11.9492 16.5829 15.8729 14.4901 18.0363 10.7434C15.8729 14.4901 16.0223 18.9349 18.037 22.4321C21.53 20.4106 23.8813 16.6357 23.8813 12.3096V3.54135C23.8813 3.00992 23.7373 2.51277 23.4891 2.08352Z"
        fill="#8BDF55"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.778 1.25586L13.7574 6.46386C10.0107 8.62729 7.91789 12.5509 7.91309 16.5871L23.0242 1.47597C22.9467 1.3978 22.8644 1.32443 22.778 1.25586Z"
        fill="#25C16F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.91309 16.5867C11.9492 16.5826 15.8729 14.4891 18.0363 10.7423L23.2443 1.72176C23.1757 1.63536 23.1023 1.55307 23.0242 1.47559L7.91309 16.5867Z"
        fill="#8BDF55"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.2447 1.72168L18.0367 10.7422C15.8732 14.489 16.0227 18.9338 18.0373 22.4316L23.4895 2.08305C23.4161 1.95619 23.3352 1.83551 23.2447 1.72168Z"
        fill="#FFBB00"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.0371 22.4316C21.5301 20.4101 23.8821 16.6352 23.8821 12.3091V3.54084C23.8821 3.00941 23.7381 2.51226 23.4892 2.08301L18.0371 22.4316Z"
        fill="#FFA800"
      />
    </svg>
  );
}
